import React from 'react';
export const StatsBar = () => {
  return <div className="bg-navy-800 border-y border-navy-700 py-6" data-id="element-299">
      <div className="max-w-6xl mx-auto px-4" data-id="element-300">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-navy-700" data-id="element-301">
          <div data-id="element-302">
            <div className="text-3xl font-serif font-bold text-yellow-400 mb-1 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-303">
              +1.200
            </div>
            <div className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-304">
              familias
            </div>
          </div>
          <div data-id="element-305">
            <div className="text-3xl font-serif font-bold text-yellow-400 mb-1 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-306">
              5
            </div>
            <div className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-307">
              Tomos
            </div>
          </div>
          <div data-id="element-308">
            <div className="text-3xl font-serif font-bold text-yellow-400 mb-1 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-309">
              5
            </div>
            <div className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-310">
              Bonos
            </div>
          </div>
          <div data-id="element-311">
            <div className="text-3xl font-serif font-bold text-yellow-400 mb-1 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-312">
              4.9/5
            </div>
            <div className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-313">
              ⭐⭐⭐⭐⭐
            </div>
          </div>
        </div>
      </div>
    </div>;
};